import { useCallback } from "react"
import { Dropdown, DropdownProps } from "@mezo-org/passport"
import { useNavigate } from "@tanstack/react-router"

import { setOpenModal, useDappDispatch } from "#/redux-state"
import { BALANCE_UPDATE_INTERVAL, routes } from "#/shared/constants"
import { useWalletDisconnect } from "#/shared/hooks"

type DashboardHeaderAccountProps = Omit<
  DropdownProps,
  "onSignIn" | "onSignOut" | "evmNativeAssets" | "matsnetAssets" | "overrides"
>

export default function DashboardHeaderAccount(
  props: DashboardHeaderAccountProps,
) {
  const dispatch = useDappDispatch()
  const navigate = useNavigate()

  const handleSignInOnClick = useCallback(() => {
    dispatch(setOpenModal("onboarding"))
  }, [dispatch])

  const handleOnOtherAssetsClick = useCallback(() => {
    navigate({
      to: `${routes.OVERVIEW}`,
    })
  }, [navigate])

  const { disconnect } = useWalletDisconnect()

  return (
    <Dropdown
      overrides={{
        Body: {
          style: {
            zIndex: 100,
          },
        },
      }}
      onSignIn={handleSignInOnClick}
      onSignOut={disconnect}
      accountDataRefetchInterval={BALANCE_UPDATE_INTERVAL}
      nativeBalanceRefetchInterval={BALANCE_UPDATE_INTERVAL}
      onOtherAssetsClick={handleOnOtherAssetsClick}
      {...props}
    />
  )
}
